export default __webpack_public_path__ + "static/media/work_web-md@2x.6e07fddb.jpg";